import React, {Component} from 'react'
import HttpClient from "../../utils/HttpClient/HttpClient";

export default class WidgetHelper {

    httpClient;
    constructor(){
        this.httpClient = new HttpClient(true);
    }

    addWidgetById(id){
        this.httpClient.put(`oga/dashboard/add/${id}`)
    }

    removeWidgetById(id){
        this.httpClient.put(`oga/dashboard/remove/${id}`)
    }

}


// WEBPACK FOOTER //
// ./src/components/Helpers/WidgetHelper.jsx